import { useState, useEffect } from "react";
import "./errorMessage.css";

export const ErrorMessage = ({ msg }) => {
    const [messageClass, setMessageClass] = useState(null);

    useEffect(() => {
        setMessageClass(`alert alert-danger d-flex align-items-center py-2 mt-3 ${msg ? "fadeIn" : "fadeOut"}`);
    }, [msg]);

    return (
        <div className={messageClass} role="alert">
            <i className={"fa fa-exclamation-triangle fa-2x me-3"}></i>
            <div>{msg}</div>
        </div>
    );
};
